<h3>MATH CIFRIS</h3>
<p>
	Il nuovo gruppo tematico Math Cifris dell'iniziativa nazionale De Componendis
	Cifris, raccoglie tutte le persone interessate agli aspetti matematici della crittografia.
	Math Cifris coopera con il gruppo UMI
	di crittografia e codici per creare seminari congiunti, i quali in questo caso saranno pubblicizzati anche sul sito
	UMI.
	A tal proposito è online la <a href="https://sites.google.com/view/crittografiaecodici/home">nuova pagina</a>
	del gruppo di crittografia e codici UMI.
</p>
<h5>Comitato organizzatore</h5>
<ul>
	<li>Maria Tota, Università di Salerno;</li>
	<li>Alessio Meneghetti, Università di Trento;</li>
	<li>Carmine Monetta, Università di Salerno.</li>
</ul>
<p>Il responsabile dell'iniziativa è Norberto Gavioli</p>

<h4>INIZIATIVE</h4>
<p>Il gruppo tematico Math Cifris ha lo scopo di organizzare: </p>
<ul>
	<li>
		Nei mesi scorsi il gruppo ha realizzato un censimento delle attività riguardanti la crittografia
		e la teoria dei codici rivolte alle scuole superiori. La scadenza era prevista per l'8 maggio 2021.
		Maggiori informazioni al <a href="../../../assets/attivita/gruppi/mathCifris/censimento.pdf">documento
			allegato</a>.
	</li>
	<li> Iniziative con le scuole, quali seminari e laboratori che permettano l'avvicinamento
		dei giovani a queste tematiche e la loro comprensione. Per collaborare con noi ed aiutarci
		a migliorare la nostra proposta: facci sapere la tua opinione, le tue idee o se nel
		tuo istituto sono stati già proposti seminari/laboratori di questo tipo, scrivendo
		un'email a <a href="mailto:matematica@decifris.it">matematica&#64;decifris.it</a>. </li>
	<li> Seminari online per illustrare risultati di ricerche ed approfondimenti di aspetti
		matematici della crittografia. </li>
	<li> Progetti dedicati allo sviluppo e all'applicazione della matematica da svolgere in aziende.</li>
	<li>Un <a href="https://sites.google.com/view/crittografiaecodici/convegno-annuale">convegno
			nazionale (annuale) di crittografia</a>, congiuntamente col gruppo UMI,
		con collaborazioni esterne di esperti provenienti non solo dal mondo accademico,
		ma anche da quello aziendale. La conferenza mira a fornire un'opportunità ai ricercatori che
		lavorano sulla crittografia e sulla teoria dei codici di mostrare i loro risultati
		ed interessi di ricerca.
	</li>
</ul>

<h4>PROSSIMI SEMINARI</h4>
<ul>
</ul>

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b>2 Novembre - 10:00</b>
		<ul>
			<li>
				<b>Luca Mariot</b> -- Radboud University <br>
				<i>"Behind the scenes of a new construction for bent functions:
					a tour among cellular automata, Latin squares and linear
					recurring sequences"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/
									MARIOT.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/
									Mariot_talk_2022.pdf">Slide</a> --
				<a href="https://mega.nz/file/A1lnkLIC#zr8FCRmq1zVLg
									8NXex3tiC0_iruKJWY7UU8fjJYU9rY">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 4 Maggio 2022 - 16:00</b>
		<ul>
			<li>
				<b>Giovanni Zini</b> -- Università degli Studi di Modena e Reggio Emilia <br>
				<i>"Funzioni Generalized APN in caratteristica dispari e curve algebriche"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato4_
									MathCifris_Locandina_05.2022-Giovanni-Zini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato2_
									Zini_MathCifris.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b>6 Aprile 2022 - 16:00</b>
		<ul>
			<li>
				<b>Marzio Mula</b> -- Università di Trento <br>
				<i>"Random sampling of supersingular elliptic curves"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/04.2022-
									Marzio-Mula.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato 1
									_SLIDE_MathCifrisMula_6Aprile.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=5ckEjOSA1uI">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Marzo 2022 - 16:00</b>
		<ul>
			<li>
				<b>Martino Borello</b> -- Université Paris 8-LAGA. <br>
				<i>"Il principio di indeterminazione dal punto di vista della
					teoria dei codici"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/03.2022-
									Martino-Borello.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Presentazi
									one_Borello.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=0DOkTuBeSYU">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Febbraio 2022</b>
		<ul>
			<li>
				<b>Irene Villa</b> -- Università degli Studi di Trento <br>
				<i>"The classification of planar monomials over fields of order
					a prime cubed"</i> <br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Irene
									VillaLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/IreneVilla
									Slide.pdf">Slide</a>
			</li>
		</ul>
	</li>
</ul>

<h4>SEMINARI PASSATI</h4>
<ul>
	<li>
		<b>1 Dicembre 2021 -- 16:00</b>
		<ul>
			<li>
				<b>Daniele Bartoli</b> -- Università degli Studi di Perugia <br>
				<i>"Teoremi di tipo Hasse-Weil e classi rilevanti di funzioni
					polinomiali"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Bartoli_Locandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/BartoliSlide.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>3 Novembre 2021 -- 16:30</b>
		<ul>
			<li>
				<b>Ilaria Zappatore</b> -- INRIA Paris <br>
				<i>"Una tecnica per costruire algoritmi resistenti agli errori
					per la risoluzione di sistemi lineari polinomiali"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/
										11.2021_Ilaria_Zappatore.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Zappatore_
									Slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=J7czOyTdIyc">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>6 Ottobre 2021 -- 16:00</b>
		<ul>
			<li>
				<b>Alessandro Neri</b> -- Max Planck Institute for Mathematics in the Sciences, Lipsia <br>
				<i>"Matrici Parziali e Polinomi non Commutativi nella Teoria dei Codici"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/AlessandroNeriLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/SlidesUMI_Neri.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=MKRg73iY1Zk">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Luglio 2021 - 16:00</b>
		<ul>
			<li>
				<b>Roberto La Scala</b> -- Università degli Studi di Bari Aldo Moro. <br>
				<i>"Cifrari ed Equazioni alle Differenze"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/LaScalaLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/LaScalaSlide.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>9 Giugno 2021 - 16:00</b>
		<ul>
			<li>
				<b>Alberto Ravagnani</b> -- Eindhoven University of Technology. <br>
				<i>"Il Codice Tipico su un Grande Alfabeto"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Ravagnani.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/RavagnaniSlides.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Maggio 2021 - 15:00</b>
		<ul>
			<li>
				<b>Luca de Feo</b> -- Université de Versailles – Saint-Quentin e IBM Zurich <br>
				<i>"La corrispondenza di Deuring effettiva – la chiave per la prossima
					generazione di crittografia basata sulle isogenie?"</i> <br>
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeo.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeoSlide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=Ktp1VVuuM9U">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>8 Aprile 2021</b>
		<ul>
			<li>
				<b>Emmanuela Orsini</b> -- COSIC, KU Leuven, Belgium <br>
				<i>"Post-quantum secure oblivious transfer"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Orsini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/PQOT.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=A54aJqzFRYM">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>10 Dicembre 2020</b>
		<ul>
			<li>
				<b>Francesco Sica</b> -- Nazarbayev University, Kazakhstan <br>
				<i>"Fattorizzazione con indizi"</i>.<br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Locandina-Sica.pdf">Locandina</a> -
				<a href="../../../assets/attivita/gruppi/mathCifris/Slide_Sica.pdf">Slide</a> -
				<a href="https://youtu.be/S3ZpmcjRDKk">Video</a>
				<br>
			</li>
		</ul>
	</li>
</ul>

<h4>SEMINARI AFFINI</h4>
<p>I membri di Math Cifris segnalano, oltre a quanto proposto sopra,
	altri seminari, organizzati da altre realtà della De Cifris, di carattere
	affine a quello di questa pagina. </p>
<ul>
	<li>
		<b>19 Aprile 2021</b> (<a routerLink="/decifris-augustaetaurinorum">De Cifris Augustae Taurinorum</a>)
		<ul>
			<li>
				<b>Roberto La Scala</b> <br>
				<i>"Cifrari ed equazioni alle differenze"</i>.<br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/LaScala.pdf">Locandina</a>
				<!-- <a href="">Slide</a> -  -->
				<!-- <a href="">Link al video</a> -->
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>26 Marzo 2021</b> (<a routerLink="/decifris-augustaetaurinorum">De Cifris Augustae Taurinorum</a>)
		<ul>
			<li>
				<b>Francesco Stocco</b> <br>
				<i>"A theoretical approach to Shor’s Algorithm and Quantum Bits"</i>.<br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Stocco.pdf">Locandina</a>
				<!-- <a href="">Slide</a> - 
									<a href="">Link al video</a> -->
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Febbraio 2021</b> (<a routerLink="/decifris-augustaetaurinorum">De Cifris Augustae Taurinorum</a>)
		<ul>
			<li>
				<b>Carlo Sanna</b> <br>
				<i>"Introduction to Multivariate Cryptography"</i>.<br>
				<a
					href="../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/locandina_Sanna.pdf">Locandina</a>
				--
				<a
					href="../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Sanna_Intro_MVC.pdf">Slide</a>
				--
				<a href="https://youtu.be/v5su7blRrHk">Video</a>
				<br>
			</li>
		</ul>
	</li>
</ul>
<h4>VIDEO</h4>
<p>I video di crittografia relativi a questo argomento sono disponibili sul nostro <a href="https://www.youtube.com/
						watch?v=S3ZpmcjRDKk&list=PLu4yxTVzRRMWZ_ALuKt8bC5Iopu_PXaw3">canale YouTube.</a></p>